import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { toast } from 'react-toastify';
import { createImgObj, getSelfie } from '../CompanyEmployees/CompanyEmployeesApi';
import {CONTRACT_SERVICE, CONTRACTOR_SERVICE, CONTRACTOR_VEHICLE_SERVICE, DOCUMENT_SERVICE, IMAGE_SERVICE, STATUS_SERVICE, WORK_SHIFT_SERVICE, ZONE_SERVICE} from "../EndPoints";
import {accessMethodModel} from "../../enums/accessMethodEnum";
import { UploadImage } from '../ShareSlice/shareApi';
import { TABLES } from '../../Apis/Tables';

// Create Contract Api's
export const CreateContract = createAsyncThunk('employeeContractor/CreateContract', async (getVal) => {
    const result = await apiInstance
        .post(CONTRACT_SERVICE.createContract, getVal)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(response.data.message);
            }
            return response;
        })
        .catch(function (error) {
            toast.error(error.response.data.message);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Create ContractV1 Api's
export const CreateContractV1 = createAsyncThunk('employeeContractor/createContractV1', async (params) => {
    const result = await apiInstance
        .post(CONTRACT_SERVICE.createContractV1, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const CreateContractWithCustom = createAsyncThunk('employeeContractor/CreateContractWithCustom', async (val) => {
    const customSchdule = JSON.stringify(val);
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.createContractWithCustom, customSchdule, {
            headers: {
                'content-Type': 'application/json',
            },
        })
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(response.data.message);
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const CreateContractWorkSchdule = createAsyncThunk('employeeContractor/createContractWorkSchedule', async (params) => {
    const { WorkShift, val } = params;
    const result = await apiInstance
        .post(WORK_SHIFT_SERVICE.createContractWorkSchedule(WorkShift, val))
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast('Contract With Work Schdule Added SuccessFully');
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    document.getElementById('overlay').style.display = 'none';

    return { data, status };
});

export const GetZoneTree = createAsyncThunk('employeeContractor/GetZoneTree', async () => {
    const result = await apiInstance
        .post(ZONE_SERVICE.getZoneTree)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllZoneTree = createAsyncThunk('employeeContractor/GetAllZoneTree', async () => {
    const result = await apiInstance
        .post(ZONE_SERVICE.getAllZoneTree)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllContractors = createAsyncThunk('employeeContractor/GetAllContractors', async () => {
    const result = await apiInstance
        .get(CONTRACTOR_SERVICE.getAllContractors)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllWorkSchdule = createAsyncThunk('employeeContractor/GetAllWorkSchdule', async () => {
    const result = await apiInstance
        .get(WORK_SHIFT_SERVICE.getAllWorkSchdule)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetWorkTimeAccess = createAsyncThunk('employeeContractor/GetWorkTimeAccess', async (params) => {
    const { id, contractPagination } = params;
    const result = await apiInstance
        .post(`${WORK_SHIFT_SERVICE.getWorkTimeAccess}${id}`, contractPagination)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllEmployeeContractors = createAsyncThunk(
    'employeeContractor/GetAllEmployeeContractors',
    async (params) => {
        const { pagination } = params || {};
        const result = await apiInstance
            .post(CONTRACTOR_SERVICE.getAllEmployeeContractors, pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;
        return { data, status };
    },
);

export const GetAllEmployeeContracts = createAsyncThunk('employeeContractor/getAllEmployeeContracts', async (param) => {
    const { inCommingActive, contractPagination } = param;
    const result = await apiInstance
        .post(`${CONTRACT_SERVICE.getAllEmployeeContracts}${inCommingActive}`, contractPagination)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });

    const { data, status } = result;
    return { data, status };
});

export const UpDateContract = createAsyncThunk('employeeContractor/UpDateContract', async (getVal) => {
    const result = await apiInstance
        .put(CONTRACT_SERVICE.upDateContract, getVal)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast('Contract Updated SuccessFully');
            }
            return response;
        })
        .catch(function (error) {
            toast.error(error.response.data.message);
            return error.response.data.message;
        });
    const { data, status } = result;
    return { data, status };
});

// Update ContractV1 Api

export const UpdateContractV1 = createAsyncThunk('employeeContractor/updateContractV1', async (params) => {
    const result = await apiInstance
        .put(CONTRACT_SERVICE.updateContractV1, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetWorkShiftByContractID = createAsyncThunk(
    'employeeContractor/GetWorkShiftByContractID',
    async (params) => {
        const { contractId, contractPagination } = params;
        const result = await apiInstance
            .post(`${WORK_SHIFT_SERVICE.getWorkShiftByContractID}${contractId}`, contractPagination)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Upload Document

export const UploadUserDocument = createAsyncThunk('employeeContractor/UploadUserDocument', async (formData) => {
    const result = await apiInstance
        .post(DOCUMENT_SERVICE.uploadUserDocument, formData)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            toast(error?.response?.data?.message);
            document.getElementById('overlay').style.display = 'none';
            return error.response;
        });

    const { data, status } = result;
    return { data, status };
});

export const GetAllVehicleByContractorId = createAsyncThunk(
    'employeeContractor/getAllVehicleByContractorId',
    async (params) => {
        const { contractId, pagination } = params;
        const result = await apiInstance
            .post(`${CONTRACTOR_VEHICLE_SERVICE.getAllVehicleByContractorIdPageable}${contractId}`, pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const GetVehicleWithDocumentById = createAsyncThunk(
    'employeeContractor/GetVehicleWithDocumentById',
    async (VehicleId) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_VEHICLE_SERVICE.getVehicleWithDocumentById}${VehicleId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const GetAllToContractor = createAsyncThunk('employeeContractor/GetAllToContractor', async () => {
    const result = await apiInstance
        .get(STATUS_SERVICE.getAllToContractor)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
//  get by employeee  contractor  by id
export const GetEmployeeContractorById = createAsyncThunk(
    'employeeContractor/getEmployeeContractorById',
    async (params) => {
        const { id } = params || {};

        const result = await apiInstance
            .get(`${CONTRACTOR_SERVICE.getEmployeeContractorById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//  create contractor
export const CreateEmployeeContractor = createAsyncThunk(
    'employeeContractor/createEmployeeContractor',
    async (params, { dispatch }) => {
        const result = await apiInstance
            .post(CONTRACTOR_SERVICE.createEmployeeContractor, params?.data)
            .then(async function (response) {
                const imgData = {
                    user: {
                        id: response?.data?.data?.userId,
                    },
                    accessMethod: {
                        id: '5',
                    },
                    description: 'Face recognition',
                };
                // want to update or create image              
               if (params?.file !== '' && params?.file != null) {
                    const {
                        payload: { data: { data, success } = {} } = {},
                    } = await dispatch(
                        createImgObj({
                            ...imgData,
                            file: params.file,
                        }),
                    );
                    if (success) {
                        let formData = new FormData();

                        formData.append('id', data.id);
                        formData.append('option', TABLES.USER);
                        formData.append('file', params?.file);

                        await dispatch(UploadImage(formData));
                    }
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//  get contractor data by it id
export const GetContractorById = createAsyncThunk(
    'employeeContractor/getContractorById',
    async (params) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_SERVICE.getContractorById}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    }
);

//  update contractor
export const UpdateContractor = createAsyncThunk(
    'employeeContractor/updateContractor',
    async (params, { dispatch }) => {
        const { setModified, data, file, updateImage } = params;

        try {
            const response = await apiInstance.put(
                CONTRACTOR_SERVICE.updateContractor,
                data,
            );

            const userId = response?.data?.data?.userId;

            const imgData = {
                user: { id: userId },
                accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                description: 'Face recognition',
            };

            if (file) {
                if (updateImage) {
                    const selfie = await dispatch(getSelfie(userId)).unwrap();
                    const formData = new FormData();
                                        formData.append('id', selfie?.data?.data?.id);
                                        formData.append('file', file);
                                         formData.append('option', TABLES.USER);
                    await dispatch(
                        UploadImage(formData),
                    );
                } else {
                    await dispatch(createImgObj({ imgData, file }));
                }
            }

            setModified(true);

            return {
                data: response.data,
                status: response.status,
            };
        } catch (error) {
            return {
                data: error?.response?.data,
                status: error?.response?.status,
            };
        }
    }
);
// approve docuemnt
export const GetAllContractorDocuments = createAsyncThunk(
    'employeeContractor/getAllContractorDocuments',
    async (params) => {
        const result = await apiInstance
            .get(`document-service/contractor/get-all/by-user-id/${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// /corporate-user-pre-prod-v2/document-service/contractor/approve-document (done)
export const ApproveContractorDocument = createAsyncThunk(
    'employeeContractor/approveContractorDocument',
    async (params) => {
        const result = await apiInstance
            // .post('document-service/contractor/approve-document', params)
            .post(DOCUMENT_SERVICE.approveContractorDocument, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//zone-servic/v1/common-area/get-all
export const GetAllCommonArea = createAsyncThunk(
    'employeeContractor/GetAllCommonArea',
    async () => {
        const result = await apiInstance
            .get(ZONE_SERVICE.getAllCommonArea)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    }
);
